/**
 * One icon the app can draw: Cleanlist's drawing for `name`
 * (candy-art.data.ts) in colour in the Candy style, its Lucide icon
 * (lucide-icons.ts) in the text colour in the Plain style.
 */
export interface IconDefinition {
  /** Kebab-case name: the key of its drawing and Lucide icon, and the
   * `data-icon` attribute. */
  name: string;
  /** The filled look for an active, selected or filled state: in the Plain
   * style a heavier line (Lucide has no filled icons). */
  solid?: boolean;
  /** A brand logo image, drawn as it is in both styles. */
  logo?: string;
  /** Draws the logo's shape in the text colour, for a one-colour logo that
   * has to read on any background (Cleanlist's own). */
  tinted?: boolean;
  /** Cleanlist's own mark (Clu): its drawing in colour in both styles. */
  mark?: boolean;
}

export function defineIcon(
  name: string,
  options: {
    solid?: boolean;
    logo?: string;
    tinted?: boolean;
    mark?: boolean;
  } = {}
): IconDefinition {
  return { name, ...options };
}
